import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import {brandDetector} from '@/brands';

let brandStyles = brandDetector();


const info = {
	state: {
		textosInfoPopup : {
			calendario : {
				titulo : 'Modelo calendario',
				texto : 'Adjunta la plantilla correspondiente, recuerda que solamente puedes aportar una plantilla, si después de aportarla deseas cambiar el modelo o actualizarla, contacta con encargado de la formalización de prácticas en UAX.'
			},
            anexo_7 : {
				titulo : 'Modelo Anexo 7',
				texto : 'Adjunta la plantilla correspondiente, recuerda que solamente puedes aportar una plantilla, si después de aportarla deseas cambiar el modelo o actualizarla, contacta con encargado de la formalización de prácticas en UAX.'
			},
		},
		owntexts : brandStyles.ownpopup_info
	},
	getters: {
		getInfoPopup : state => {
			return (value) => {
				let textos;

				if(state.owntexts){
					textos = (!!state.owntexts[value]) ? state.owntexts[value] : state.textosInfoPopup[value];
				}else{
					textos = state.textosInfoPopup[value];
				}

				return textos;
			}
		},
	},
	actions: {
		
	},
	mutations: {
		
	}
}

export default info;



// WEBPACK FOOTER //
// ./src/store/popup-info.js